import { Component, OnInit } from '@angular/core';
import { NavigationService } from 'src/app/_services/navigation-service.service';

@Component({
  selector: 'app-footer-tabs',
  templateUrl: './footer-tabs.component.html',
  styleUrls: ['./footer-tabs.component.scss'],
})
export class FooterTabsComponent  implements OnInit {

  constructor(private navigationService: NavigationService) { }

  ngOnInit() {}
  goTo(destination: string) {
    this.navigationService.navigateTo(`prestataire/${destination}`);
  }

}
